// removed by extract-text-webpack-plugin
module.exports = {"bubble":"_2BdUb","bubble-open":"_2NEBB","bubble-container":"_5DIwP","trigger":"_2weSm","trigger-open":"_3dWqx","bubble-option-container":"_2vpI9","option":"_2vqjA","modal-container":"_3v4md","modal-title":"zY-8u","close":"_2A5a_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/FeaturedFilterBubble.less
// module id = ./src/components/Home/FeaturedFilterBubble.less
// module chunks = 2